// extracted by mini-css-extract-plugin
export default {"heading":"zA-z","corrected":"AA-z","redirectVerbiageContainer":"BA-z","redirectVerbiageText":"CA-z"};